import { useState } from "react";
import { createPortal } from "react-dom";
import { CSSProperties } from "@mui/styles/withStyles";
import { Box } from "@mui/material";

/**
 * Renders the buttons that TableBasedCrud builds (Add and friends) next to the page title instead of
 * on top of the filters bar, the way Time off lays out its own header actions.
 *
 * The table keeps building and wiring the button; only where it lands in the DOM changes, so pass
 * `toolbarActionsSlot` as the toolbar's `rightContent` and wrap the page's builder with
 * `addButtonInToolbar`.
 */
export const useToolbarActions = () => {
  const [slot, setSlot] = useState<HTMLDivElement | null>(null);

  const toolbarActionsSlot = <Box ref={setSlot} sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1.5 }} />;

  const addButtonInToolbar =
    (buildButton: (onClick: () => void, style?: CSSProperties) => JSX.Element) => (onClick: () => void, style?: CSSProperties) =>
      // Empty until the slot mounts, one render later.
      slot ? createPortal(buildButton(onClick, style), slot) : <></>;

  return { toolbarActionsSlot, addButtonInToolbar };
};
